/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="m2.0743 8.18 6.7198-5.3757c.6875-.55 1.7059-.0606 1.7059.8199V8.25h6.75C20.9779 8.25 24 11.272 24 15s-3.0221 6.75-6.75 6.75H.75a.75.75 0 0 1 0-1.5h16.5c2.8995 0 5.25-2.3505 5.25-5.25s-2.3505-5.25-5.25-5.25H10.5v4.6258c0 .8798-1.017 1.3692-1.7045.8211l-.0014-.0012-6.7198-5.3758c-.5254-.4203-.5254-1.2195 0-1.6398ZM3.4506 9 9 13.4395v-8.879L3.4506 9Z"
    clipRule="evenodd"
  />,
  'Return'
);
